import DashboardIcon from '@mui/icons-material/Dashboard';
import DraftsIcon from '@mui/icons-material/Drafts';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import SettingsBackupRestore from '@mui/icons-material/SettingsBackupRestore';
import { Routes } from '@shared/domain/router/route/route.aggregate';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';

export const ROUTES: Routes<
  OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string;
  }
> = {
  DASHBOARD: {
    id: 1,
    path: '/',
    label: 'Dashboard',
    Icon: DashboardIcon
  },
  USERS: {
    id: 2,
    path: '/users',
    label: 'Users',
    Icon: ManageAccountsIcon
  },
  THERAPIES: {
    id: 3,
    path: '/therapies',
    label: 'Therapies',
    Icon: ApartmentIcon
  },
  TOPICS: {
    id: 4,
    path: '/topics',
    label: 'Topics',
    Icon: ThreeDRotationIcon
  },
  SUBTOPICS: {
    id: 5,
    path: '/subtopics',
    label: 'Subtopics',
    Icon: AddCircleIcon
  },
  SUBTOPICS_FILTERED: {
    id: 6,
    path: '/therapies/:therapyId/topics/:topicId/subtopics/',
    label: 'Subtopics',
    Icon: AddCircleIcon
  },
  SUBTOPICS_EDIT: {
    id: 7,
    path: '/therapies/:therapyId/topics/:topicId/subtopics/:subtopicId',
    Icon: DraftsIcon
  },
  SUBTOPICS_CREATE: {
    id: 8,
    path: '/therapies/:therapyId/topics/:topicId/subtopics/create',
    Icon: DraftsIcon
  },
  TOPICS_EDIT: {
    id: 9,
    path: '/therapies/:therapyId/topics/:topicId',
    Icon: DraftsIcon
  },
  TOPICS_CREATE: {
    id: 10,
    path: '/topics/create',
    Icon: DraftsIcon
  },
  CONTENTS: {
    id: 11,
    path: '/contents',
    label: 'Contents',
    Icon: VideoFileIcon
  },
  CONTENTS_EDIT: {
    id: 12,
    path: '/contents/:contentId',
    label: 'Contents',
    Icon: VideoFileIcon
  },
  CONTENTS_CREATE: {
    id: 13,
    path: '/contents/create',
    label: 'Contents',
    Icon: VideoFileIcon
  },
  SNAPSHOTS: {
    id: 14,
    path: '/snapshots',
    label: 'Snapshots',
    Icon: SettingsBackupRestore
  },
};

export const SIDEBAR_ROUTES_LIST = [
  ROUTES.DASHBOARD,
  ROUTES.USERS,
  ROUTES.THERAPIES,
  ROUTES.TOPICS,
  ROUTES.SUBTOPICS,
  ROUTES.CONTENTS,
  ROUTES.SNAPSHOTS
];
